import React from 'react';
import strings from '../../lang/strings.js';
import { PageSettings } from "../../config/page-settings.js";
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import 'react-datetime/css/react-datetime.css';
import '../../config/util.js';
import U from '../../config/util.js';
import ImageSelect from '../../components/content/image-select.jsx';


class ProductCompanyEditPopup extends React.Component {
    static contextType = PageSettings;

    constructor(props) {
        super(props);

        this.state = {
            item: {},
            image_url: "",
        };

        this.toggleModal = this.toggleModal.bind(this);
        this.image_file = null;
    }

    componentDidMount() {
    }

    toggleModal(result) {
        if (this.props.onClose) {
            this.props.onClose(result);
        }
    }

    getData = () => {
        this.setState({
            item: this.props.data ?? {},
            image_url: U.getThumbUrl(this.props.data?.image_url ?? "")
        });
        this.image_file = null;
    };

    uploadData = (image_files, callback) => {

        let formData = new FormData();
        image_files.forEach((entry, index) => {
            formData.append('file', entry, entry.name);
        });


        this.context.post(
            'upload/images/restaurant',
            formData,
            function (response) {
                callback(response.result_data.upload_path);
            },
            true
        );
    }

    saveData = () => {
        let self = this;

        if (this.image_file) {
            this.uploadData([this.image_file], function (image_url) {
                self.state.image_url = U.getThumbUrl(image_url);
                self.image_file = null;
                self.saveData();
            });
            return;
        }

        const item = self.state.item;
        item.image_url = self.state.image_url.replace('_thumb.', '.').url2String();

        if (!item.title) {
            self.context.addNotification('warning', strings.alert_title, strings.empty_title);
            return;
        }

        if (!item.image_url) {
            self.context.addNotification('warning', strings.alert_title, strings.empty_main_image);
            return;
        }

        this.context.post('product/saveCompanyItem',
            {
                company_info: item
            }, function (response) {
                self.context.addNotification('success', strings.alert_title, strings.save_done);
                if (self.props.onSave) {
                    self.props.onSave();
                }
            }, true);
    };

    onDataChange = (e) => {
        let item = this.state.item;
        item[e.target.id] = e.target.value;

        this.setState({
            item: item
        });
    };

    onImageChange = (e) => {
        let self = this;

        if (e.target.files.length < 1) {
            return;
        }

        let file = e.target.files[0];
        let reader = new FileReader();

        reader.onloadend = function () {
            self.setState({ image_url: reader.result });
            self.image_file = file
        };
        reader.readAsDataURL(file);
    };

    render() {
        let item = this.state.item;

        return (
            <div>
                <Modal isOpen={this.props.isOpen} toggle={this.toggleModal} onOpened={() => this.getData()}>
                    <ModalHeader className="popup-nickname" toggle={this.toggleModal}>{'상품 회사 등록'}</ModalHeader>
                    <ModalBody>
                        <div className="row">
                            <div className="col-xs-12">
                                <div className='row'>
                                    <label className='col-md-3 col-form-label'>{strings.title} *</label>
                                    <div className="col-md-9">
                                        <input type='text' autoComplete='off' className='form-control' id='title'
                                            value={item.title ?? ''}
                                            onChange={(e) => this.onDataChange(e)} />
                                    </div>
                                </div>
                                <div className='row mt-1'>
                                    <label className='col-md-3 col-form-label'>{strings.image}</label>
                                    <div className="col-md-9">
                                        <div className='row mb-1'>
                                            <div className='col-xs-4 col-sm-3 col-md-5 col-lg-4 col-xl-4 col-xxl-3'>
                                                <ImageSelect
                                                    height="70%"
                                                    image_url={this.state.image_url}
                                                    onSelect={(e) => this.onImageChange(e)}
                                                    onDelete={() => {
                                                        this.setState({ image_url: '' });
                                                        this.image_file = null;
                                                    }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-default" onClick={this.toggleModal}>{strings.close}</button>
                        <button className="btn btn-success" onClick={() => this.saveData()}>{strings.apply}</button>
                    </ModalFooter>
                </Modal>
            </div >
        )
    }
}

export default ProductCompanyEditPopup;